export function dataInRequest(params = {}) {
  return {
    type: '@raizenerrologintegracaoentradacomboio/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@raizenerrologintegracaoentradacomboio/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@raizenerrologintegracaoentradacomboio/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@raizenerrologintegracaoentradacomboio/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@raizenerrologintegracaoentradacomboio/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@raizenerrologintegracaoentradacomboio/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@raizenerrologintegracaoentradacomboio/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@raizenerrologintegracaoentradacomboio/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@raizenerrologintegracaoentradacomboio/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@raizenerrologintegracaoentradacomboio/RECORD_FILTERING',
    payload: { params },
  };
}
